import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f28baafc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f28baafc&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=f28baafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28baafc",
  null
  
)

export default component.exports